import React from "react";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import Spinner from "../shared/Spinner";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden } from "@material-ui/core";
import { colors } from "../../theme";
import Image from "./svg/join.svg";
import Button from "../shared/Button";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: "3px",
    border: `solid 2px ${colors.JOIN_DISCUSSION_BG}`,
    backgroundColor: colors.JOIN_DISCUSSION_BG,
    padding: "16px",
    marginTop: "50px",
    marginBottom: "50px",
  },
  title: {
    fontSize: "40px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.09px",
    color: colors.JOIN_DISCUSSION_TEXT,
  },
  text: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.67",
    letterSpacing: "-0.05px",
    color: colors.JOIN_DISCUSSION_TEXT,
    "&:not(:first-child)": {
      marginTop: "20px",
    },
  },
  buttonContainer: {
    textAlign: "center",
  },
  button: {
    width: "200px",
    marginTop: "10px",
  },
  image: {
    width: "331px",
    height: "275px",
  },
}));

export default function JoinTheDiscussion() {
  const classes = useStyles();
  const { t, ready } = useTranslation(["content"]);

  if (!ready) return <Spinner isVisible={true} />;

  return (
    <Grid container item xs={12}>
      <Hidden mdDown>
        <Grid item xs={2} />
      </Hidden>
      <Grid container item xs={12} sm={12} md={8} className={classes.container}>
        <Hidden mdDown>
          <Grid item md={4} lg={6}>
            <img
              src={Image}
              alt={t("jointhediscussion.title")}
              className={classes.image}
            />
          </Grid>
        </Hidden>

        <Grid container item md={8} lg={6} sm={12} direction="column">
          <Grid item>
            <Typography component="p" className={classes.title}>
              {t("jointhediscussion.title")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography component="p" className={classes.text}>
              {t("jointhediscussion.paragraph_one")}
            </Typography>
            <Typography component="p" className={classes.text}>
              {t("jointhediscussion.paragraph_two")}
            </Typography>
            <Typography component="p" className={classes.text}>
              {t("jointhediscussion.paragraph_three")}
            </Typography>
            <Typography component="p" className={classes.text}>
              {t("jointhediscussion.paragraph_four")}
            </Typography>
          </Grid>
          <Grid item className={classes.buttonContainer}>
            <Button linkTo="/signup" className={classes.button}>
              {t("jointhediscussion.signup")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Hidden mdDown>
        <Grid item xs={2} />
      </Hidden>
    </Grid>
  );
}
